/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MousePointer = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z" }],
    ["path", { d: "m13 13 6 6" }]
  ]
];

export { MousePointer as default };
//# sourceMappingURL=mouse-pointer.js.map
